<template>
  <div class="shop">
    <div class="shop-type" :class="`shop-type-${$bus.shopType}`">
      <DiscountText />
      <PrizeComponent />
      <TicketComponent />
      <Tab />
    </div>
    <div class="kite" ref="kite"></div>
    <div class="cake" :class="{'cake-hide': $bus.shopType !== 'fishing'}"></div>
  </div>
</template>

<script>
import Tab from './tab'
import DiscountText from '@/components/business-base/discount-text'
import PrizeComponent from './prize'
import TicketComponent from './ticket'
import anime from '@/utils/animation'

export default {
  components: {
    Tab,
    DiscountText,
    PrizeComponent,
    TicketComponent
  },
  mounted () {
    this.runAnimateKite()
  },
  methods: {
    // animate kite
    runAnimateKite () {
      anime.animateKite(this.$refs.kite)
    }
  }
}
</script>

<style lang="scss" scoped>
.shop {
  position: relative;
  @include px2res(width, 918);
  @include px2res(height, 673);

  .shop-type {
    @include px2res(width, 878);
    height: 100%;
    transition: background-image 0.6s ease-in;
  }

  .kite {
    position: absolute;
    right: 0;
    @include px2res(bottom, 120);
    @include px2res(width, 113);
    @include px2res(height, 202);
    transform-origin: top left;
  }

  .cake {
    position: absolute;
    @include px2res(left, 72);
    @include px2res(bottom, 148);
    @include px2res(width, 85);
    @include px2res(height, 117);
    transition: opacity 0.6s ease-in;

    &.cake-hide {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/index.vue